import { Component, inject } from "@angular/core";
import { SkillRestService } from "@app/services/hal/skill-rest.service";
import { Skill } from "@app/models/rest/skill";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogActions
} from "@angular/material/dialog";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { MatFormField, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-skill-editor",
  templateUrl: "./skill-editor.component.html",
  styleUrls: ["./skill-editor.component.scss"],
  imports: [
    MatDialogTitle,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class SkillEditorComponent {
  private skillService = inject(SkillRestService);
  dialogRef = inject<MatDialogRef<SkillEditorComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  skillForm = new UntypedFormGroup({
    skillFC: new UntypedFormControl("")
  });

  editMode = false;
  skill: Skill;

  constructor() {
    // if (data.mode === 'EDIT') {
    //   this.editMode = true;
    //   this.skill = { ...data.skill };
    // } else {
    this.skill = new Skill();
    this.skill.description = null;
    // }
  }

  getErrorMessage(controlName: string) {
    console.log(this.skillForm.controls[controlName].errors);
    console.log("get error");
    return this.skillForm.controls[controlName].errors.server;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    // if (this.data.mode === 'EDIT') {
    //   this.skillService.update(this.skill);
    //   this.dialogRef.close();
    // } else {
    const skill: Skill = new Skill();

    skill.description = this.skillForm.controls["skillFC"].value;

    this.skillService.createResource({ body: skill }).subscribe(
      () => {
        console.log("success");
        this.dialogRef.close({ success: true });
      },
      (error) => {
        console.log("error");
        console.log(error);
        // alert(error.error.message);
      }
    );
  }

  onDescriptionChanged(event) {
    this.skill.description = event.target.value;
  }
}
